// extracted by mini-css-extract-plugin
export default {"inputContainer":"style_inputContainer__ttMTJ"};